import { render, staticRenderFns } from "./ValidationCell.vue?vue&type=template&id=61139296&scoped=true&"
import script from "./ValidationCell.vue?vue&type=script&lang=js&"
export * from "./ValidationCell.vue?vue&type=script&lang=js&"
import style0 from "./ValidationCell.vue?vue&type=style&index=0&id=61139296&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61139296",
  null
  
)

export default component.exports